import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants/constants";
import { getValueFromStorage } from "../helpers/helpers";

export const PurchaseApi = createApi({
  reducerPath: "purchase",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-type", "application/json");
      headers.set("authorization", `Bearer ${getValueFromStorage("token")}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPurchases: builder.query({
      query: () => ({
        url: `/api/purchase`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPurchasesQuery, useLazyGetPurchasesQuery } = PurchaseApi;
